module.exports = __webpack_public_path__ + "img/stone3.71efe094.png";